import type { Mission } from '../missions.ts'

export const dhsIa: Mission = {
  id: "dhs-ia",
  name: "Office of Intelligence and Analysis",
  short: "I&A",
  call: "Homeland Intelligence",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.dhs.gov/office-intelligence-and-analysis",
  palette: {
    primary: "#005187",
    secondary: "#c0c2c4",
    accent: "#c4122f",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:DHS_Intelligence_and_Analysis_seal.png",
  },
  motif: "star",
  mission: {
    text: "The core of I&A's mission is to enable the seamless flow of information to state, local, tribal, territorial, and private sector partners to empower them to detect, prevent, and respond to threats effectively.",
    url: "https://www.dhs.gov/office-intelligence-and-analysis",
  },
  fact: {
    text: "I&A is the only Intelligence Community element charged by statute with both delivering intelligence to state, local, tribal, territorial, and private sector partners and synthesizing information from them.",
    url: "https://www.dhs.gov/office-intelligence-and-analysis",
  },
  seal: {
    file: "public/seals/dhs-ia.png",
    source: "https://commons.wikimedia.org/wiki/File:DHS_Intelligence_and_Analysis_seal.png",
  },
  identifier: {
    about: "https://www.dhs.gov/office-intelligence-and-analysis",
    accessibility: "https://www.dhs.gov/accessibility",
    foia: "https://www.dhs.gov/foia",
    noFear: "https://www.dhs.gov/homeland-security-no-fear-act-reporting",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.dhs.gov/performance-financial-reports",
    privacy: "https://www.dhs.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/dhs-ia-operations-center.jpg",
        small: "/media/dhs-ia-operations-center-sm.jpg",
        alt: "Rows of workstations with multiple monitors fill the DHS National Operations Center, where staff monitor threats to the homeland.",
        title: "DHS National Operations Center, Washington, D.C., January 26, 2021",
        creator: "U.S. Department of Homeland Security",
        source: "https://commons.wikimedia.org/wiki/File:Acting_Secretary_Pekoske_Visits_the_DHS_National_Operations_Center_(50888013092).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
